
// const PRODUCT_TYPE_ATTRIBUTE = "product_product_type";

// const StoreConfig = {
//     apiKey: 'MW83K3JVRkhiUDhlMXp2a3FYaXVJK0tZUG9CdWRRSFBLTmljN0lJcTVxMVVIV2xYb0pBeUZ0SGhzRkRyOXFBK0NwNWpQQjBtK1I4SDdTT0VXVTRsekE9PQ==',
//     storeId: '209b6e42d41811f0a0cf0a0c8095feae',
//     storeSecret: null,
//     baseUrl: 'https://api.wizsearch.in/v1'
// };

const productGenderMap = {
  "T Shirt": ["Men", "Women"],
  "Tops": ["Women"],
  "Shirt": ["Men", "Women"],
  "Cardigan": ["Men", "Women"],
  "Vest": ["Men", "Women"],
  "Dress": ["Women"],
  "Hoodie": ["Men", "Women"],
  "Sweater": ["Men", "Women"],
  "Knits": ["Men", "Women"],
  "Woven": ["Men", "Women"],
  "Sweatshirt": ["Men", "Women"],
  "Bottoms": ["Men", "Women"],
  "Denims": ["Men", "Women"],
  "Shorts": ["Men", "Women"],
  "Trousers": ["Men", "Women"],
  "Pants": ["Men", "Women"],
  "Skirts": ["Women"],
  "Footwear": ["Women", "Men"],
  "Jewelry": ["Women"],
  "Hats / Hair": ["Men", "Women"],
  "Bags": ["Women"],
  "Sunglass": ["Women", "Men"]
};


function getGenders(productType) {
    return productGenderMap[productType]; 
}
// console.log(JSON.stringify(recommendationMap, null, 2)); 
// const colors = [
//     "White",
//     "Grey",
//     "Blue",
//     "Khaki",
//     "Indigo",
//     "Black",
//     "Brown",
//     "Red",
//     "Orange",
//     "Purple",
//     "Pink",
//     "Green",
//     "Multi",
//     "Yellow"
// ];


function getBestProductType(rawType) {
  if (!rawType) return null;

  const type = rawType.toLowerCase();

  // 1exact match
  let exact = productTypes.find(pt => pt.toLowerCase() === type);
  if (exact) return exact;

  // contains (either direction)
  let contains = productTypes.find(pt => {
    const p = pt.toLowerCase();
    return type.includes(p) || p.includes(type);
  });
  if (contains) return contains;

  // “best overlap” score
  let best = null;
  let bestScore = 0;

  productTypes.forEach(pt => {
    const p = pt.toLowerCase();
    // score = number of shared characters
    const score = [...p].filter(c => type.includes(c)).length;
    if (score > bestScore) {
      bestScore = score;
      best = pt;
    }
  });

  return best;
}


// const productTypes = [
//     "T Shirt",
//     "Tops",
//     "Shirt",
//     "Cardigan",
//     "Vest",
//     "Dress",
//     "Hoodie",
//     "Sweater",
//     "Knits",
//     "Woven",
//     "Sweatshirt",
//     "Bottoms",
//     "Denims",
//     "Shorts",
//     "Trousers",
//     "Pants",
//     "Skirts",
//     "Footwear",
//     "Jewelry",
//     "Hats / Hair",
//     "Bags",
//     "Sunglass"
// ];
async function fetchFilteredProduct(config) {
    let {
        productType,
        gender,
        color,
        productsCount
    } = config;
    
    const apiKey = StoreConfig.apiKey;
    const storeId = StoreConfig.storeId;
    const baseUrl = StoreConfig.baseUrl;

    if (!apiKey || !storeId) {
        throw new Error('Missing required credentials: apiKey, storeId, and storeSecret are required');
    }

    
    const url = `${baseUrl}/products/filter`;
    const headers = {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
        'x-store-id': storeId,
    };

    const filters = {};
    const attributes = {};
    if (productType) {
        console.log("Product type of product", productType);
        if(productType == "T Shirt")
        {
            productType = "T-Shirt";
        }
        else if(productType == "Bottom Wear")
        {
            productType = "Bottoms";
        }
        attributes.product_product_type = Array.isArray(productType) ? productType : [productType];
    }
    
    const colors = [];
    if (color) {
        const colorArray = Array.isArray(color) ? color : [color];

        const capitalizedColors = colorArray.map(c => {
            if (!c) return c; // skip null/undefined

            const str = String(c).trim(); // ensure string + remove spaces

            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        });

        console.log(capitalizedColors);
        colors.push(...capitalizedColors);
    }

    const genders = [];
    if (gender) {
        const genderArray = Array.isArray(gender) ? gender : [gender];
        genders.push(...genderArray);
    }
    // filters.colors = colors;
    let q = window.wzShopTheLookContext?.name;

    if (q) {
        const lastDashIndex = Math.max(
            q.lastIndexOf("-"),
            q.lastIndexOf("–")
        );

        if (lastDashIndex !== -1) {
            q = q.substring(0, lastDashIndex).trim();
        }
    }
    filters.genders = genders;
    filters.q = q;
    filters.attributes = attributes;
    filters.inStock = [];
    filters.productsCount = productsCount || 1;
    filters.sort = [{ field: 'relevance', order: 'asc' }, { field: 'createdAt', order: 'desc' }];

    // Reusable function
    const callApi = async (filtersObj) => {
        const requestBody = {
            filters: JSON.stringify(filtersObj),
            group: "default"
        };

        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
                `API Error: ${response.status} ${response.statusText}. ` +
                (errorData.message || 'Unknown error occurred')
            );
        }

        return response.json();
    };

    try {
        const currentProductId = String(window.wzShopTheLookContext.id);

        let data = await callApi(filters);
        let products = data?.payload?.result || [];

        // Remove current product
        products = products.filter(
            p => String(p.groupId || p.id) !== currentProductId
        );
        console.log("wiz", products);

        // If less than required products, fetch more without the name query.
        // Ask for the products we already have plus a full page, because the
        // second response starts with the same products and those get removed.
        if (products.length < filters.productsCount) {
            const productKey = (p) => String(p.groupId || p.id);

            const fallbackFilters = {
                ...filters,
                q: "",
                productsCount: products.length + filters.productsCount
            };

            const fallbackData = await callApi(fallbackFilters);

            let fallbackProducts = fallbackData?.payload?.result || [];

            fallbackProducts = fallbackProducts.filter(
                p => productKey(p) !== currentProductId
            );

            const existingIds = new Set(products.map(productKey));

            fallbackProducts = fallbackProducts.filter(
                p => !existingIds.has(productKey(p))
            );

            console.log("wiz fallback", fallbackProducts, products);

            products = [...products, ...fallbackProducts];
        }

        // console.log("wizzy shop similar 1", data);

        // // Final fallback (remove color filter)
        // if (products.length === 0) {

        //     const fallbackFilters = { ...filters };
        //     delete fallbackFilters.colors;

        //     data = await callApi(fallbackFilters);
        //     products = data?.payload?.result || [];

        //     // Remove current product
        //     products = products.filter(
        //         p => String(p.groupId) !== currentProductId
        //     );
        // }

        console.log("wiz final", products);

        // Final safety: ensure current product and duplicates are removed
        const seen = new Set();

        products = products.filter(p => {
            const id = String(p.groupId || p.id);

            if (id === currentProductId || seen.has(id)) {
                return false;
            }

            seen.add(id);
            return true;
        });

        products = products.slice(0, filters.productsCount);

        console.log("wiz final 1", products);

        if (products.length > 0) {
            return {
                success: true,
                total: products.length,
                data: {
                    payload: {
                        result: products,
                        total: products.length
                    }
                    }
                };
        }

        return {
            success: true,
            product: null,
            total: 0,
            message: "No products found matching the criteria",
        };

    } catch (error) {
        console.error("Error fetching filtered product:", error);

        return {
            success: false,
            error: error.message,
            product: null
        };
    }
}
async function fetchProducts(data)
{
    console.log("Shop similar", data);
    if(data)
    {
        const result = await fetchFilteredProduct({
            productType: data.product,
            gender: data.gender,
            color: data.color,
            productsCount: data.productsCount
        });
        console.log("wiz Result", result);
        return result?.data?.payload?.result;
    }
    
    // if (result.success) {
    //     if (result.product) {
    //         console.log('Product found:', result.product);
    //         return result.product;
    //     } else {
    //         console.log('No products found matching the criteria');
    //         return null;
    //     }
    // } else {
    //     console.error('Error:', result.error);
    //     return null;
    // }
}
let flag = 0;
function renderProduct(products)
{
    console.log("Shop similar products", products);
    if(products)
    {
        products.forEach((product) => {

            console.log("Product=====>", product);
            if(product.groupId !== window.wzShopTheLookContext.id)
            {
                flag = 1;
                const templateEl = document.getElementById("wizzy-search-results-product");
                if (!templateEl) return;

                const rawTpl = templateEl.innerHTML;
                console.log(product.id);
                // Tell Mustache to use [[ ]] (so it matches your template)
                Mustache.tags = ["[[", "]]"];

                // test product (your sample)
                const productData = {
                    id: product.id,
                    groupId: product.groupId,
                    name: product.name,
                    url: product.url,
                    mainImage: product.mainImage,
                    images: product.images,
                    hoverImage: product.hoverImage,
                    inStock: product.inStock,
                    sellingPrice: product.sellingPrice,
                    price: product.price,
                    discountPercentage: null,
                    singleVarientGroupId: null
                };
                console.log(productData);
                const html = Mustache.render(rawTpl, productData);

                const container = document.querySelector(".wz_ss_products");
                if (container) {
                    container.insertAdjacentHTML("beforeend", html);
                }
            }
        })
        if(flag)
        document.querySelector(".wz_shop_similar_wrapper").style.setProperty("display", "block", "important");
    }
    
}
document.addEventListener("DOMContentLoaded", function () {
    if(window.wzShopTheLookContext.productType != '' && window.wzShopTheLookContext.gender != '')
    {
        
        // let product_type = getBestProductType(window.wzShopTheLookContext.productType);
        let product_type = window.wzShopTheLookContext.productType;
        
        let genders = [];
        let tags = window.wzShopTheLookContext.tags;
        if (tags && tags.some(tag => ["Woman", "Women"].includes(tag))) {
            genders.push("Women");
        }
        if (tags && tags.some(tag => ["Man", "Men", "menswear"].includes(tag))) {
            genders.push("Men");
        }
        if(product_type == "Dress" || product_type == "Dresses")
        {
            product_type = ["Dress", "Dresses"];
        }
        if(product_type == "Co-ord set" || product_type == "Co-ord Sets" || product_type == "Co-ord sets" || product_type == "Co-Ord Set")
        {
            product_type = ["Co-ord set", "Co-ord Sets", "Co-ord sets", "Co-Ord Set"];
        }
        if(product_type == "Jumpsuit" || product_type == "Jumpsuits")
        {
            product_type = ["Jumpsuit", "Jumpsuits"];
        }
        if(product_type == "Kurta" || product_type == "Kurtas")
        {
            product_type = ["Kurta", "Kurtas"];
        }
        if(product_type == "Mens" || product_type == "men")
        {
            product_type = ["Mens", "men"];
        }
        if(product_type == "Shirt" || product_type == "Shirts")
        {
            product_type = ["Shirt", "Shirts"];
        }
        if(product_type == "Skirt" || product_type == "Skirts")
        {
            product_type = ["Skirt", "Skirts"];
        }
        if(product_type == "T-Shirt" || product_type == "T-Shirts")
        {
            product_type = ["T-Shirt", "T-Shirts"];
        }
        if(product_type == "Women" || product_type == "women")
        {
            product_type = ["Women", "women"];
        }
        if(product_type == "Kurta Sets" || product_type == "kurta sets" || product_type == "Kurta-Sets")
        {
            product_type = ["Kurta Sets", "kurta sets", "Kurta-Sets"];
        }


        const anchor = {
            gender: genders,
            product: product_type,
            color: window.wzShopTheLookContext.color,
            productsCount: 6
        };

        const products = fetchProducts(anchor).then(result => {
            renderProduct(result);
        })
        // console.log("product1", product1);
        // if(product1)
        // {
        //     renderProduct(product1);
        // }

    }
});


// TODO: fetch those products and render UI here
// console.log(recs);

